import React from 'react';
import { useParams } from 'react-router-dom';

import GeneralRankingTable from '../../components/GeneralRankingTable';
import RankingDatesRangePicker, { useRankingDatesRangePicker } from '../../components/RankingDatesRangePicker';

import { useGeneralRanking } from '../../hooks';

interface GeneralRankingPageProps {
  studentsMode?: boolean;
}

const GeneralRankingPage = (props: GeneralRankingPageProps) => {
  const { studentsMode = false } = props;

  const { courseId } = useParams<{ courseId: string }>();

  const { props: rankingDateRangePickerProps, from, to } = useRankingDatesRangePicker();
  const { students, stats, error, loading, onRefetchRanking, courseName } = useGeneralRanking({ courseId, from, to });
  return (
    <GeneralRankingTable
      downloadFileName={courseName}
      getGeneralRanking={onRefetchRanking}
      students={students}
      stats={stats}
      loading={loading}
      studentsMode={studentsMode}
      error={error}
      datesPicker={<RankingDatesRangePicker {...rankingDateRangePickerProps} />}
    />
  );
};

export default GeneralRankingPage;
